import { ICTTLSetBehavior } from '@tencent/slide-sdk-model';
import { AttrName } from '../interface';
import BaseAnimKeyframeHandler from './base-anim-keyframe-handler';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IConverterToStyle } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
export default class SetHandler<M extends IElementBaseModel> extends BaseAnimKeyframeHandler<ICTTLSetBehavior, M> {
    protected behavior: ICTTLSetBehavior;

    public parse(
        behavior: ICTTLSetBehavior,
        duration: number,
        elementModel: M,
    ): IConverterToStyle| undefined {
        super.parse(behavior, duration, elementModel);

        if (!this.behavior.to?.clrVal) return;
        const tempToStyle = this.getKeyframeData(duration);
        return tempToStyle;
    }

    protected convertToRgbaColor(attrName: AttrName): string | undefined {
        return this.handleRGBSpace(this.behavior.to?.clrVal);
    }
}
